import React, { useState, useEffect } from 'react';
import BreakCrumbs from '../../components/BreakCrumbs';
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import TableLoading from '../../components/TableLoading';
import { alertError } from '../../Util/Util';
import TableEmpty from '../../components/TableEmpty';
import {
  BonusProductQRCodeStatus,
  BonusProductQRCodeStatusText,
  LIST_PAGE_COUNT,
} from '../../data/common';
import { trim, map } from 'lodash';
import { useHistory } from 'react-router';
import bonusProductAPI from '../../middleware/bonusProductAPI';
import BonusProductQRCodeTable from '../../components/BonusProduct/BonusProductQRCodeTable';
import QrCodeWithLogo from 'qrcode-with-logos';

const BonusProductQRCodeList = (props) => {
  const { match } = props;
  const [qrcodes, setQRCodes] = useState();
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState({
    status: BonusProductQRCodeStatus.ALL,
    bonusProductId: undefined,
    productPackageId: undefined,
  });
  const [page, setPage] = useState(1);

  useEffect(() => {
    handleSearch();
  }, [page]);

  const handleChangeSearch = (e) => {
    setSearch({
      ...search,
      [e.target.name]: e.target.value,
    });
  };

  const handleSearch = () => {
    setIsLoading(true);

    bonusProductAPI
      .getQRCodes(
        page,
        LIST_PAGE_COUNT,
        search.status,
        search.bonusProductId,
        search.productPackageId,
      )
      .then(
        (res) => {
          setQRCodes(res.bonusProductQRCodeList);
          setTotal(res.totalCount);
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const handleSetPage = (page) => {
    setPage(page);
  };

  const downloadQRCode = async (QRCode) => {
    setIsLoading(true);

    const fileName =
      trim(QRCode.bonusProductQRCodeId) +
      '-' +
      QRCode.bonusProductInfo.name +
      '.png';
    const qrcodeCanvas = document.createElement('canvas');
    const qrcode = new QrCodeWithLogo({
      canvas: qrcodeCanvas,
      content: QRCode.qRCodeValue,
      width: 100,
      nodeQrCodeOptions: {
        margin: 1,
      },
    });

    qrcode.downloadImage(fileName);

    setIsLoading(false);
  };

  return (
    <div className="popular pagefadeIn">
      <BreakCrumbs path={match.url}></BreakCrumbs>

      <Box component={Paper} square elevation={2} p={1} mt={3} mb={3}>
        <Grid
          container
          direction="row"
          justify="space-around"
          alignItems="center">
          <Grid item xs>
            <Typography variant="h4" color="textPrimary" gutterBottom>
              紙本序號列表
            </Typography>
          </Grid>
        </Grid>

        <Divider light />

        <Box textAlign="right" mt={2} mb={2}>
          <FormControl
            size="small"
            variant="outlined"
            style={{ marginRight: '12px', minWidth: '150px' }}
            disabled={isLoading}>
            <InputLabel>狀態</InputLabel>
            <Select
              value={search.status}
              name="status"
              onChange={handleChangeSearch}
              label="狀態">
              {map(BonusProductQRCodeStatusText, (text, status) => {
                return (
                  <MenuItem value={status} key={status}>
                    {text}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            disabled={isLoading}
            onClick={() => {
              if (page !== 1) {
                setPage(1);
              } else {
                handleSearch();
              }
            }}>
            搜尋
          </Button>
        </Box>

        {isLoading && <TableLoading />}

        {!isLoading && !qrcodes && <TableEmpty message="無序號" />}

        {!isLoading && qrcodes && (
          <BonusProductQRCodeTable
            QRCodes={qrcodes}
            total={total}
            page={page}
            setPage={handleSetPage}
            isLoading={isLoading}
            downloadQRCode={downloadQRCode}
          />
        )}
      </Box>
    </div>
  );
};

export default BonusProductQRCodeList;
